"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_ENTRY_LEVELS = void 0;
exports.GET_ENTRY_LEVELS = `
	{
		getEntryLevels: {
			slug
		}
	}
`;
//# sourceMappingURL=entry-level-queries.js.map